import { FunctionComponent } from "react";

interface ProgressBarItemsProps {
  title: string;
  id: string;
  active: string;
  index: number;
  setActivePage: Function;
}

const ProgressBarItem: FunctionComponent<ProgressBarItemsProps> = ({
  title,
  id,
  active,
  index,
  setActivePage,
}) => {
  return (
    <button
      onClick={() => setActivePage(id)}
      className={`pb-px px-3 lg:pb-2 lg:px-4 uppercase cursor-pointer focus:outline-none border-b-2 ${
        active === id ? "border-primary" : "border-white"
      }`}
    >
      <div className="text-xs lg:hidden">
        {active === id ? `${index + 1}. ${title}` : `${index + 1}. `}
      </div>
      <div className="hidden lg:block ">{title}</div>
    </button>
  );
};

export default ProgressBarItem;
